import { SortingConfiguration, CouponButtonPosition, CMSConfig } from "../../../Typings";

export const cmsConfig: CMSConfig = {
    numberOfTopLeagues: 5,
    numberOfAllLeaguesShownByDefault: 5,
    showTopLeaguesList: true,
    sortingLogic: SortingConfiguration.Alphabetically,
    sportsExcludedFromAlphabeticalSorting: ["2", "5"],
    isCouponCreationEnabled: true,
    maxCouponLeagues: 5,
    couponButtonPosition: CouponButtonPosition.Fixed,
    showCouponButtonBottom: false,
    regionId: "6"
}